import { useNavigate } from 'react-router-dom';
import { DesktopLayout } from '@/components/desktop/DesktopLayout';
import { AccountRecoveryHeader } from '@/components/desktop/auth/AccountRecoveryHeader';
import { AccountRecoveryOptions } from '@/components/desktop/auth/AccountRecoveryOptions';

export function DesktopFindAccountPage() {
  const navigate = useNavigate();

  // 모바일 로직 재사용
  const handleFindId = () => {
    navigate('/find-id');
  };

  const handleResetPassword = () => {
    navigate('/reset-password');
  };

  return (
    <DesktopLayout>
      <div className="min-h-[80vh] flex items-center justify-center py-12">
        <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg border border-gray-200 px-12 py-16">
          
          {/* Header Section - SRP: 헤더 표시만 담당 */}
          <AccountRecoveryHeader 
            title="계정정보 찾기"
            className="mb-16"
          />
          
          {/* Options Section - SRP: 선택 옵션만 담당 */}
          <AccountRecoveryOptions
            onFindId={handleFindId}
            onResetPassword={handleResetPassword}
          />
        </div>
      </div>
    </DesktopLayout>
  );
}